import React, {
  Component,
  PropTypes,
} from 'react'

import { Icon, Radio } from 'antd'

import { TextEllipsis } from '../../styled'
import {
  encodeQueryUrl,
  decodeQueryUrl,
} from '../../utils'
import _BtnShowMore from '../btnShowMore'
import ShowMore from '../../components/layouts/showMore'
import playerWhite from '../../assets/player_white.png'
import _cardExamProduct from '../cardExamProduct'
import _cardPackage from '../cardPackage'
// import coinPic from '../../assets/coin_ver2_02.png'

class BannerProduct extends Component {
  static propTypes = {
    banners: PropTypes.object.isRequired,
    onLoadBanner: PropTypes.func.isRequired,
    sortType: PropTypes.number.isRequired,
    productAll: PropTypes.array.isRequired,
    params: PropTypes.string.isRequired,
    onChangeRoute: PropTypes.func.isRequired,
    info: PropTypes.object.isRequired,
  }

  componentDidMount () {
    const {
      onLoadBanner,
    } = this.props
    onLoadBanner()
  }
  redirect = (queryUrl) => {
    const {
      onChangeRoute,
    } = this.props
    // window.location.href = `?${queryUrl}`
    // onChangeRoute(window.location.href.concat(`?${queryUrl}`))
    onChangeRoute(`?${queryUrl}`)
  }
  fetchObjectToQueryUrlAndRedirect = (objectSelect) => {
    const {
      params,
    } = this.props
    let queryUrlObj = decodeQueryUrl(params)
    return encodeQueryUrl({ ...queryUrlObj, ...objectSelect })
  }
  compare = (a, b) => {
    if (a.coin < b.coin) {
      return -1
    }
    if (a.coin > b.coin) {
      return 1
    }
    return 0
  }
  spendTime = (time) => {
    let second = (time / 1000)
    let minutes = second / 60
    second %= 60
    let hours = (minutes / 60)
    minutes %= 60

    let h = Math.floor(hours) === 0 ? '00' : `${Math.floor(hours)}`
    let m = Math.floor(minutes) === 0 ? '00' : `${Math.floor(minutes)}`
    let s = Math.ceil(second) === 0 ? '00' : `${Math.ceil(second)}`
    h = Math.floor(h) > 9 ? `${Math.floor(h)}` : `0${Math.floor(h)}`
    m = Math.floor(m) > 9 ? `${Math.floor(m)}` : `0${Math.floor(m)}`
    s = Math.floor(s) > 9 ? `${Math.floor(s)}` : `0${Math.floor(s)}`

    let t = [h, m, s]
    return t.join(':')
    // return <span> {Math.floor(hours) === 0 ? '00' : `${Math.floor(hours)} :` } {Math.floor(minutes) === 0 ? '00' : `${Math.floor(minutes)} :`} {Math.ceil(second) === 0 ? '00' : `${Math.ceil(second)} `}</span>
  }
  onChangeType = (e) => {
    const objHistory = {
      sortType: e.target.value,
    }
    const queryUrl = this.fetchObjectToQueryUrlAndRedirect(objHistory)
    this.redirect(queryUrl)
  }
  isInMylib = (id, typeOfProduct) => {
    const {
      info,
    } = this.props
    if (typeOfProduct === "course"){
      return info.myLibCourse.filter( myCourse => myCourse.product._id === id).length > 0
    } else if (typeOfProduct === "exam"){
      return info.myLibExam.filter( myExam => myExam.product._id === id).length > 0
    }
    return info.myLibPackage.filter( myPackage => myPackage.product._id === id).length > 0
  }
  typeOfProduct = (product) => {
    if(product.exams !== undefined){
      return 'exam'
    } else if (product.courses !== undefined) {
      return 'course'
    }
    return 'package'
  }
  showPricebyTypeOfProduct = (examPrivate, coinPriceDate, id, typeOfProduct) => {
    const {
      info,
    } = this.props
    if (this.isInMylib(id, typeOfProduct)) {
      if(typeOfProduct === "exam") {
        // return (<div className="containerPriceCoin" style={{ fontSize: '13px' }} ><div className="containerCoin" >เริ่มสอบ</div></div>)
        return (<span>เริ่มสอบ</span>)
      } else if(typeOfProduct === "course"){
        return (<span>เริ่มเรียน</span>)
      } else {
        return (<span>ซื้อแล้ว</span>)
      }
    } else if (examPrivate === 0 && coinPriceDate.length > 1) {
      return (<span> {`${coinPriceDate.sort(this.compare)[0].coin} ~ ${coinPriceDate.sort(this.compare)[coinPriceDate.length - 1].coin}`} บาท</span>)
    } else if (examPrivate === 0 && coinPriceDate.length === 1) {
      return (<span> {`${coinPriceDate[0].coin}`} บาท</span>)
    } else if (examPrivate === 1) {
      return (<span> ฟรี</span>)
    }
    return ''
  }
  courseContainer = (value, index) => {
    return (<li className="product bannerProduct" key={index} style={{ display: index < 9 ? '' : 'none' }}>
    <div className="containerImg">
      <a href={`/course/${value._id}`} className="picture">
        <img src={value.product.promotional.imageURL_16_9} alt="" />
      </a>
      <div className="videoLength">
        <img src={playerWhite} alt="" style={{ width: '15px', height: '15px', margin: '4% 9%' }} />
        <span>{this.spendTime(value.videoLength)}</span>
      </div>
    </div>
    <div className="product-name custom-product-name-test">
      <a href={`/course/${value._id}`}><TextEllipsis>{value.productName}</TextEllipsis></a>
      <span style={{ fontSize: '13px', color: '#b0b0b0' }} >{value.uploaders[0].displayName}</span>
    </div>
    <div className="star-rating" title={`Rated ${value.rating.avg} out of 5`} style={{ display: 'inline-flex' }}>
      <span style={{ width: `${value.rating.avg * 20}%` }} /><div style={{ display: 'inline', marginTop: '-2px', fontSize: '12px' }}>({value.rating.user})</div>
    </div>
    {/* <span className="price">
      <span className="amount">
        {value.product.coinPriceDate.length !== 0 && value.product.coinPriceDate[0].coin !== null && (typeof value.product.coinPriceDate[0].coin !== 'undefined') ?
          <span>
            <img src={coinPic} alt="" style={{ width: '12px', display: 'inline-block', marginRight: '5px', marginTop: '2px' }} /> {`${value.product.coinPriceDate.sort(this.compare)[0].coin} ~ ${value.product.coinPriceDate.sort(this.compare)[value.product.coinPriceDate.length - 1].coin}`}
          </span>
          : ''
        }
      </span>
    </span> */}
    <span className="price">
      <span className="amount">
        {this.showPricebyTypeOfProduct(typeof value.private !== 'undefined' ? value.private : 0, value.coinPriceDate, value._id, this.typeOfProduct(value))}
      </span>
    </span>
  </li>)
  }
  examContainer = (exam, index) => {
    const {
      info,
    } = this.props
    return (<li className="product bannerProduct" key={index} style={{ display: index < 9 ? '' : 'none' }}>
    <div className="picture">
      <a href={`/eTestingOverview/${exam._id}`} className="cws-right fancy cws-slide-left ">
        <img src={exam.promotional.imageURL_1_1} data-at2x={exam.promotional.imageURL_1_1} alt="" />
      </a>
    </div>
    <div className="product-name custom-product-name-test">
      <a href={`/eTestingOverview/${exam._id}`}><TextEllipsis>{exam.productName}</TextEllipsis></a>
    </div>
    <div style={{ lineHeight: '20px' }}>
      <span>จำนวนคำถาม : {exam.exams.numQuestion}</span>
    </div>
    <div className="star-rating" title={`Rated ${exam.rating.avg} out of 5`} style={{ display: 'inline-flex' }}>
      <span style={{ width: `${exam.rating.avg * 20}%` }} /><div style={{ display: 'inline', marginTop: '-2px', fontSize: '12px' }}>({exam.rating.user})</div>
    </div>
    <span className="price">
      <span className="amount">
      {this.showPricebyTypeOfProduct(typeof exam.private !== 'undefined' ? exam.private : 0, exam.coinPriceDate, exam._id, this.typeOfProduct(exam))}
      </span>
    </span>
  </li>)
  // return(<div className="bannerProduct">
  //   <_cardExamProduct
  //     key={index}
  //     imgURL={exam.promotional.imageURL_1_1}
  //     productName={exam.productName}
  //     coin={exam.coinPriceDate ? exam.coinPriceDate : []}
  //     numQuestion={exam.exams.numQuestion}
  //     rating={exam.rating.avg}
  //     userrating={exam.rating.user}
  //     href={`/eTestingOverview/${exam._id}`}
  //     myLibExam={info.myLibExam}
  //     isInMylib={this.isInMylib(exam._id, this.typeOfProduct(exam))}
  //   /></div>
  // )
  }
  packageContainer = (value, index) => {
    return (<li className="product bannerProduct" key={index} style={{ display: index < 9 ? '' : 'none' }}>
    <div className="containerImg">
      <a href={`/packageDetail/${value._id}`} className="picture">
        <img src={value.promotional.imageURL_16_9} alt="" />
      </a>
      {/* <div className="videoLength">
        <img src={playerWhite} alt="" style={{ width: '15px', height: '15px', margin: '4% 9%' }} />
        <span>{this.spendTime(value.videoLength)}</span>
      </div> */}
    </div>
    <div className="product-name custom-product-name-test">
      <a href={`/packageDetail/${value._id}`}><TextEllipsis>{value.productName}</TextEllipsis></a>
      <span style={{ fontSize: '13px', color: '#b0b0b0' }} >{value.uploaders[0].displayName}</span>
    </div>
    <div className="star-rating" title={`Rated ${value.rating.avg} out of 5`} style={{ display: 'inline-flex' }}>
      <span style={{ width: `${value.rating.avg * 20}%` }} /><div style={{ display: 'inline', marginTop: '-2px', fontSize: '12px' }}>({value.rating.user})</div>
    </div>
    {/* <span className="price">
      <span className="amount">
        {value.product.coinPriceDate.length !== 0 && value.product.coinPriceDate[0].coin !== null && (typeof value.product.coinPriceDate[0].coin !== 'undefined') ?
          <span>
            <img src={coinPic} alt="" style={{ width: '12px', display: 'inline-block', marginRight: '5px', marginTop: '2px' }} /> {`${value.product.coinPriceDate.sort(this.compare)[0].coin} ~ ${value.product.coinPriceDate.sort(this.compare)[value.product.coinPriceDate.length - 1].coin}`}
          </span>
          : ''
        }
      </span>
    </span> */}
    <span className="price">
      <span className="amount">
        {this.showPricebyTypeOfProduct(typeof value.private !== 'undefined' ? value.private : 0, value.coinPriceDate, value._id, this.typeOfProduct(value))}
      </span>
    </span>
  </li>)
  }
  timeLeft = (times) => {
    let time = times - Date.now()
    let second = (time / 1000)
    let minutes = second / 60
    second %= 60
    let hours = (minutes / 60)
    minutes %= 60
    let days = (hours / 24)
    hours %= 24

    if (Math.floor(days) > 0) {
      return <div style={{ color: '#4E8CAE' }} ><span >หมดอายุใน {Math.floor(days)} วัน</span></div>
    } else if (Math.floor(hours) > 0) {
      return <div style={{ color: '#4E8CAE' }} ><span >หมดอายุใน {Math.floor(hours)} ชั่วโมง</span></div>
    } else if (Math.floor(minutes) > 0) {
      return <div style={{ color: '#4E8CAE' }} ><span >หมดอายุใน {Math.floor(minutes)} นาที</span></div>
    } else if (Math.ceil(second) > 0) {
      return <div style={{ color: '#4E8CAE' }} ><span >หมดอายุใน {Math.ceil(second)} วินาที</span></div>
    }
    return <div style={{ color: '#f27c66' }} ><span >หมดอายุ</span></div>
  }
  render () {
    const { banners } = this.props
    const {
      sortType,
      productAll,
    } = this.props
    const myLibCourseContainer = {
      contain: (
        <div>
          <ul className="products">
            {
              productAll.map((value, index) => (
                value.courses !== null ? this.courseContainer(value, index)
                  : value.exams !== null ? this.examContainer(value, index) : this.packageContainer(value, index)
              ))
            }
          </ul>
          {
            <_BtnShowMore product={productAll} cName={'bannerProduct'} num={8} w={'10%'} />
          }
        </div>
      ),
    }

    return (
      <div>
        {banners!== null?
          <div>
            <div className="page-content woocommerce">
              <div className="container clear-fix">
                <div className="">
                  <div className="columns-col columns-col-12">
                    <img src={banners.bannerImage_21_9} alt="" style={{ position: 'relative', width: '100%' }} />
                    <br />
                    <div id="page-meta" style={{ textAlign: 'unset' }}>
                      <div className="columns-col columns-col-8" >
                        <div style={{ fontSize: '16px', color: '#595959' }}>เรียงลำดับตาม</div>
                      </div>
                      <Radio.Group value={sortType} onChange={this.onChangeType} style={{ float: 'right' }}>
                        <Radio.Button value="0">ชื่อ</Radio.Button>
                        <Radio.Button value="1">วันที่เผยแพร่</Radio.Button>
                        <Radio.Button value="2">ความนิยม</Radio.Button>
                      </Radio.Group>
                    </div>
                    {
                      banners!== null  ?
                        <div>
                          {
                            <ShowMore
                              dataSource={myLibCourseContainer}
                            />
                          }
                        </div>
                      :
                        <div className="container-404">
                          <Icon type="play-circle-o" style={{ fontSize: '70pt', color: '#D8D8D8', marginBottom: 10 }} />
                          <p style={{ fontSize: 20 }}>
                            คุณยังไม่มีรายการคอร์สเรียนที่ลงทะเบียนเเล้ว
                          </p>
                        </div>
                  }
                  </div>
                </div>
              </div>
            </div>
          </div> : ''
        }
        </div>
    )
  }
}

export default BannerProduct



// WEBPACK FOOTER //
// ./src/components/pages/bannerProduct.js